//This script fetches the lowest price from last 30 days from the omnibus API and places it in the Rebuy widgets DOM

document.addEventListener('rebuy.init', (event) => {
  console.log(event.detail);
  if (event.detail.widget) {
    fetchAndApplyLowestPrice(event.detail.widget);
  }
});

document.addEventListener('rebuy.productsChange', function (event) {
  console.log(event.detail);
  if (event.detail.widget) {
    fetchAndApplyLowestPrice(event.detail.widget);
  }
});

document.addEventListener('rebuy.selectedVariantChange', function (event) {
  console.log(event.detail);
  if (event.detail.widget && event.detail.product) {
    fetchAndApplyLowestPrice(event.detail.widget, event.detail.product);
  }
});

function fetchAndApplyLowestPrice(widget, product = null) {
  const shp = window.Shopify;

  var products = [];

  if (product) {
    products.push(product);
  } else if (!product && widget.data.products) {
    products = widget.data.products;
  }

  products.forEach((product) => {
    const r = '/apps/am-omnibus-price';
    fetch(r, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        shop: shp.shop,
        productId: product.id,
        variantId: product.selected_variant_id,
        locale: shp.locale,
        currency: shp.currency,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        const html = data?.lowestPriceHtml;
        if (!html) return;

        const prdct = widget.template.querySelector(`.rebuy-product-block.product-id-${product.id}`);
        if (!prdct) return;

        const priceBox = prdct.querySelector('.rebuy-product-price');
        if (!priceBox) return;

        const lowestPriceEl = document.createElement('div');
        lowestPriceEl.className = 'rebuy-lowest-price';
        lowestPriceEl.innerHTML = html;

        const existingLowestPriceEl = priceBox.querySelector('.rebuy-lowest-price');
        if (existingLowestPriceEl) {
          priceBox.replaceChild(lowestPriceEl, existingLowestPriceEl);
        } else {
          priceBox.appendChild(lowestPriceEl);
        }
      })
      .catch((err) => {
        console.error('Error loading lowest price:', err);
      });
  });
}
